<template>
  <div>
    <h1 class="mb-2 mt-1">Product Type Data</h1>

    <category-summary-table
      :hint-id="14"
      category="producttype"
      route-name="product-type-details"
      param-name="ptid"
      name-label="Product Type"
    >
      <template #title>
        Product Types
      </template>
    </category-summary-table>
  </div>
</template>

<script>
import CategorySummaryTable from './CategorySummaryTable.vue'

export default {
  components: {
    CategorySummaryTable,
  },
}
</script>
